<template>
  <v-dialog v-model="show" persistent width="50%">
    <v-card>
      <v-card-title class="headline dark lighten-2" primary-title>
        {{ $t("global.privacy_policy_title") }}
      </v-card-title>

      <v-card-text class="py-5">
        <Component :is="currentLoadedContent" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="cancel()">
          {{ $t("global.privacy_close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    locale: {
      type: String,
      required: true
    }
  },

  components: {
    "content-en": () => import("@/themes/partials/shared/privacy_contents/content.en"),
    "content-no": () => import("@/themes/partials/shared/privacy_contents/content.no")
  },

  computed: {
    currentLoadedContent: function() {
      return "content-" + this.locale
    }
  },

  created() {},

  methods: {
    cancel() {
      this.$emit("callback_privacy_cancel")
    }
  }
}
</script>
